// import React, { useState, useEffect } from 'react';
// import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
// import { 
//   FiHome, 
//   FiBriefcase, 
//   FiUsers, 
//   FiBarChart2, 
//   FiMail, 
//   FiClipboard, 
//   FiFileText,
//   FiMap,
//   FiLogOut,
//   FiMenu,
//   FiX,
//   FiFilePlus,
//   FiPlusCircle,
//   FiList,
//   FiChevronDown,
//   FiCreditCard,
//   FiGift,
//   FiTag,
//   FiAward,
//   FiUserCheck,
//   FiCalendar,
//   FiDollarSign,
//   FiSettings,
//   FiShield,
//   FiStar,
//   FiTrendingUp,
//   FiZap,
// } from 'react-icons/fi';
// import { motion, AnimatePresence } from 'framer-motion';
// import axios from 'axios';

// const AdminLayout = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
//   const [walletCoins, setWalletCoins] = useState(null);
//   const [walletLoading, setWalletLoading] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Fetch wallet data
//   const fetchWalletData = async () => {
//     const clientId = localStorage.getItem('clientId');
    
//     if (!clientId) {
//       console.log('No clientId found in localStorage');
//       return;
//     }

//     setWalletLoading(true);
//     try {
//       const response = await axios.get(`https://api.ingrainsystems.com/api/clients/my-wallet/${clientId}`);
//       if (response.data.success) {
//         setWalletCoins(response.data.data.totalCoins);
//       }
//     } catch (error) {
//       console.error('Error fetching wallet data:', error);
//     } finally {
//       setWalletLoading(false);
//     }
//   };

//   // Check if screen is mobile on mount
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 1024) {
//         setIsSidebarOpen(false);
//       } else {
//         setIsSidebarOpen(true);
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
    
//     // Fetch wallet data
//     fetchWalletData();
    
//     // Optional: Refresh wallet data every 30 seconds
//     const interval = setInterval(fetchWalletData, 30000);
    
//     return () => {
//       window.removeEventListener('resize', handleResize);
//       clearInterval(interval);
//     };
//   }, []);

//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
//   const toggleMobileSidebar = () => setIsMobileSidebarOpen(!isMobileSidebarOpen);

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate('/client-login');
//   };

//   const handleMouseMove = (e, itemName) => {
//     setTooltipPosition({
//       x: e.clientX + 15,
//       y: e.clientY - 10,
//     });
//     setHoveredItem(itemName);
//   };

//   const toggleDropdown = (dropdownName) => {
//     setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
//   };

//   // Organized menu structure with all sections integrated and tags
//   const menuSections = [
//     {
//       // title: "Main Dashboard",
//       items: [
//         { 
//           path: '/recruitment-dashboard', 
//           label: 'Dashboard', 
//           icon: FiHome,
//           // description: 'Overview & Analytics'
//         }
//       ]
//     },
//     {
//       title: "Job Management",
//       icon: FiBriefcase,
//       type: "dropdown",
//       items: [
//         { 
//           path: '/job-post', 
//           label: 'All Jobs', 
//           icon: FiBriefcase,
//         },
//         { 
//           path: '/post-new-job', 
//           label: 'Post New Job', 
//           icon: FiPlusCircle,
//           tag: { text: 'NEW', color: 'emerald' }
//         },
//         { 
//           path: '/job-positions-status', 
//           label: 'Job Status', 
//           icon: FiList,
//         },
//         { 
//           path: '/job-applicants', 
//           label: 'Job Applicants', 
//           icon: FiUsers,
//         },
//         { 
//           path: '/score', 
//           label: 'Scores', 
//           icon: FiBarChart2,
//         }
//       ]
//     },
//     {
//       title: "Short Jobs",
//       icon: FiZap,
//       type: "dropdown",
//       items: [
//         { 
//           path: '/short-jobs', 
//           label: 'Post Short Job', 
//           icon: FiStar,
//         },
//         { 
//           path: '/posted-short-jobs', 
//           label: 'Posted Short Jobs', 
//           icon: FiList,
//         },
//         { 
//           path: '/short-job-applicants', 
//           label: 'Short Job Applicants', 
//           icon: FiUserCheck,
//         }
//       ]
//     },

//     {
//       // title: "Assessments & Documents",
//       items: [
//         { 
//           path: '/assessment-manager', 
//           label: 'Assessments', 
//           icon: FiClipboard,
//           // description: 'Manage assessments'
//         },
//         { 
//           path: '/new-assessment', 
//           label: 'New Assessment', 
//           icon: FiFilePlus,
//           // description: 'Create assessment',
//           tag: { text: 'NEW', color: 'emerald' }
//         },
//         { 
//           path: '/personal-documents', 
//           label: 'Personal Docs', 
//           icon: FiFileText,
//           // description: 'Employee documents'
//         },
//         { 
//           path: '/all-medical-certificates', 
//           label: 'Medical Certificates', 
//           icon: FiFileText,
//           // description: 'Medical records'
//         }
//       ]
//     },
//     {
//       // title: "Communications",
//       items: [
//         { 
//           path: '/acceptance-letter', 
//           label: 'Acceptance Letters', 
//           icon: FiMail,
//           // description: 'Offer letters'
//         },
//         { 
//           path: '/employee-journey', 
//           label: 'Employee Journey', 
//           icon: FiMap,
//           // description: 'Track employee progress'
//         }
//       ]
//     },
//     {
//       // title: "Wallet & Rewards",
//       items: [
//         { 
//           path: '/mywallet', 
//           label: 'My Wallet', 
//           icon: FiCreditCard,
//           // description: 'View balance & transactions'
//         },
//         { 
//           path: '/myreffral', 
//           label: 'Refer & Earn', 
//           icon: FiGift,
//           // description: 'Invite friends & earn rewards'
//         },
//         { 
//           path: '/specialoffers', 
//           label: 'Special Offers', 
//           icon: FiTag,
//           // description: 'Exclusive deals & discounts',
//           tag: { text: 'HOT', color: 'orange', icon: FiZap }
//         }
//       ]
//     }
//   ];

//   // Flatten all items for tooltip and active checking
//   const allNavItems = menuSections.flatMap(section => section.items);

//   const SidebarContent = () => (
//     <div className="flex flex-col h-full relative">
//       {/* Animated Gradient Border */}
//       <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-400 to-transparent animate-border-pulse" />
      
//       {/* Header */}
//       <div className="relative flex items-center justify-between h-14 px-4 bg-blue-900/40 border-b border-blue-700/50 backdrop-blur-sm">
//         <div className={`flex items-center gap-2 transition-all duration-300 ${!isSidebarOpen && 'lg:hidden'}`}>
//           <motion.div 
//             whileHover={{ scale: 1.05 }}
//             className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white shadow-lg"
//           >
//             <span className="text-xs font-bold">IG</span>
//           </motion.div>
//           <div>
//             <span className="font-bold text-white text-sm">INGRAIN-HIRE</span>
//             <p className="text-[9px] text-blue-300/80">Management System</p>
//           </div>
//         </div>
        
//         {!isSidebarOpen && (
//           <motion.div 
//             initial={{ scale: 0 }}
//             animate={{ scale: 1 }}
//             className="hidden lg:block w-8 h-8 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg"
//           >
//             <span className="text-white font-bold text-xs">HR</span>
//           </motion.div>
//         )}
        
//         <button 
//           onClick={toggleSidebar} 
//           className="hidden lg:flex p-1.5 rounded-lg text-blue-200 hover:text-white hover:bg-white/10 transition-all duration-200"
//         >
//           <FiMenu size={18} strokeWidth={2.5} />
//         </button>
        
//         <button 
//           onClick={toggleMobileSidebar} 
//           className="lg:hidden p-1.5 rounded-lg text-blue-200 hover:text-white hover:bg-white/10 transition-all duration-200"
//         >
//           <FiX size={18} strokeWidth={2.5} />
//         </button>
//       </div>

//       {/* Menu Sections */}
//       <nav className="flex-1 px-3 py-2 overflow-y-auto custom-scrollbar ">
//         {menuSections.map((section, sectionIdx) => (
//           <div key={sectionIdx} className="mb-1">
//             {!isSidebarOpen ? (
//               // Show only icons in collapsed mode
//               <div className="space-y-1">
//                 {section.items.map((item, idx) => (
//                   <div key={idx} className="relative">
//                     <NavLink
//                       to={item.path}
//                       onClick={() => setIsMobileSidebarOpen(false)}
//                       onMouseEnter={(e) => handleMouseMove(e, item.label)}
//                       onMouseMove={(e) => handleMouseMove(e, item.label)}
//                       onMouseLeave={() => setHoveredItem(null)}
//                       className={({ isActive }) => `group relative flex items-center justify-center p-2.5 rounded-xl transition-all duration-200 ${
//                         isActive 
//                           ? 'bg-gradient-to-r from-emerald-600/80 to-emerald-500/80 text-white shadow-lg' 
//                           : 'text-blue-200 hover:text-white hover:bg-white/10'
//                       }`}
//                     >
//                       <item.icon size={18} strokeWidth={2.5} />
//                     </NavLink>
//                     {item.tag && (
//                       <div className={`absolute -top-1 -right-1 w-2 h-2 rounded-full animate-blink ${
//                         item.tag.color === 'orange' ? 'bg-orange-500' : 'bg-emerald-500'
//                       }`} />
//                     )}
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               // Expanded view with section titles
//               <>
//                 <div className="px-2 mb-0.5 mt-2">
//                   <span className="text-[9px] font-bold uppercase tracking-wider text-white">
//                     {section.title}
//                   </span>
//                 </div>
//                 <div className="space-y-1">
//                   {section.type === "dropdown" ? (
//                     // Dropdown section (like Job Management)
//                     <>
//                       <div
//                         onClick={() => toggleDropdown(section.title)}
//                         className="flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 text-white hover:text-white hover:bg-white/10"
//                       >
//                         <div className="flex items-center gap-3">
//                           {section.icon && <section.icon size={18} strokeWidth={2.5} className="text-blue-300" />}
//                           <span className="text-[13px] font-medium">{section.title}</span>
//                         </div>
//                         <FiChevronDown 
//                           className={`transition-transform duration-300 ${openDropdown === section.title ? 'rotate-180' : ''}`}
//                           size={14}
//                         />
//                       </div>
                      
//                       <AnimatePresence>
//                         {openDropdown === section.title && (
//                           <motion.div
//                             initial={{ opacity: 0, y: -10 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             exit={{ opacity: 0, y: -10 }}
//                             className="ml-4 space-y-1"
//                           >
//                             {section.items.map((item, idx) => (
//                               <NavLink
//                                 key={idx}
//                                 to={item.path}
//                                 onClick={() => setIsMobileSidebarOpen(false)}
//                                 className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
//                                   isActive 
//                                     ? 'bg-emerald-600/80 text-white' 
//                                     : 'text-blue-200 hover:text-white hover:bg-white/5'
//                                 }`}
//                               >
//                                 <item.icon size={16} strokeWidth={2.5} />
//                                 <div className="flex-1">
//                                   <div className="flex items-center gap-2">
//                                     <span className="text-[12px]">{item.label}</span>
//                                     {item.tag && (
//                                       <span className={`text-[7px] font-bold px-1 py-0.5 rounded-full flex items-center gap-0.5 ${
//                                         item.tag.color === 'orange' 
//                                           ? 'bg-orange-500/20 text-orange-400' 
//                                           : 'bg-emerald-500/20 text-emerald-400'
//                                       }`}>
//                                         {item.tag.icon && <item.tag.icon size={6} />}
//                                         {item.tag.text}
//                                       </span>
//                                     )}
//                                   </div>
//                                 </div>
//                               </NavLink>
//                             ))}
//                           </motion.div>
//                         )}
//                       </AnimatePresence>
//                     </>
//                   ) : (
//                     // Regular items
//                     section.items.map((item, idx) => (
//                       <NavLink
//                         key={idx}
//                         to={item.path}
//                         onClick={() => setIsMobileSidebarOpen(false)}
//                         className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
//                           isActive 
//                             ? 'bg-gradient-to-r from-emerald-600/80 to-emerald-500/80 text-white shadow-lg' 
//                             : 'text-blue-200 hover:text-white hover:bg-white/10'
//                         }`}
//                       >
//                         {({ isActive }) => (
//                           <>
//                             <div className="relative">
//                               <item.icon 
//                                 size={18} 
//                                 strokeWidth={2.5}
//                                 className={`transition-all ${isActive ? 'text-white' : 'text-blue-300 group-hover:text-white'}`}
//                               />
//                               {item.tag && !isActive && (
//                                 <div className={`absolute -top-2 -right-2 w-2.5 h-2.5 rounded-full animate-blink ${
//                                   item.tag.color === 'orange' ? 'bg-orange-500' : 'bg-emerald-500'
//                                 }`} />
//                               )}
//                             </div>
//                             <div className="flex-1">
//                               <div className="flex items-center gap-2">
//                                 <span className="text-[13px] font-medium">{item.label}</span>
//                                 {item.tag && (
//                                   <motion.span
//                                     initial={{ scale: 0 }}
//                                     animate={{ scale: 1 }}
//                                     transition={{ 
//                                       type: "spring",
//                                       stiffness: 260,
//                                       damping: 20
//                                     }}
//                                     className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full flex items-center gap-0.5 animate-soft-blink ${
//                                       item.tag.color === 'orange' 
//                                         ? 'bg-orange-500/20 text-orange-400 border border-orange-500/30' 
//                                         : 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30'
//                                     }`}
//                                   >
//                                     {item.tag.icon && <item.tag.icon size={8} className="animate-pulse-fast" />}
//                                     {item.tag.text}
//                                   </motion.span>
//                                 )}
//                               </div>
//                               <p className="text-[9px] text-blue-300/60 group-hover:text-blue-200/80">
//                                 {item.description}
//                               </p>
//                             </div>
//                             {isActive && (
//                               <motion.div 
//                                 layoutId="activeIndicator"
//                                 className="w-1.5 h-1.5 rounded-full bg-emerald-300"
//                               />
//                             )}
//                           </>
//                         )}
//                       </NavLink>
//                     ))
//                   )}
//                 </div>
//               </>
//             )}
//           </div>
//         ))}
//       </nav>

//       {/* Bottom Section - Only Logout and Footer */}
//       <div className="border-t border-blue-700/50 bg-blue-900/20 backdrop-blur-sm p-3">
//         {!isSidebarOpen ? (
//           // Collapsed sidebar - icons only
//           <div className="flex flex-col items-center gap-2">
//             <button
//               onClick={handleLogout}
//               onMouseEnter={(e) => handleMouseMove(e, 'Sign Out')}
//               onMouseMove={(e) => handleMouseMove(e, 'Sign Out')}
//               onMouseLeave={() => setHoveredItem(null)}
//               className="group relative p-2.5 rounded-xl text-red-300 hover:bg-red-500/20 hover:text-red-200 transition-all duration-200"
//             >
//               <FiLogOut size={18} strokeWidth={2.5} />
//             </button>

//             {/* Version indicator */}
//             <div className="mt-2 pt-2 border-t border-blue-700/30 w-full flex justify-center">
//               <div className="w-6 h-6 rounded-lg bg-white/5 flex items-center justify-center">
//                 <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-blink" />
//               </div>
//             </div>
//           </div>
//         ) : (
//           // Expanded sidebar - Logout and Footer only
//           <div className="space-y-2">
//             <div className="h-px bg-gradient-to-r from-blue-500/30 to-transparent" />

//             <button
//               onClick={handleLogout}
//               className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-red-300 hover:bg-red-500/20 hover:text-red-200 transition-all duration-200"
//             >
//               <FiLogOut size={18} strokeWidth={2.5} />
//               <div>
//                 <span className="text-[13px] font-medium">Sign Out</span>
//                 <p className="text-[9px] text-red-300/60">Exit application</p>
//               </div>
//             </button>

//             {/* Footer */}
//             <div className="pt-3 mt-2 border-t border-blue-700/30">
//               <div className="flex items-center justify-between mb-1">
//                 <p className="font-semibold tracking-wider text-blue-300/60 text-[8px] uppercase">v2.0</p>
//                 <div className="flex items-center gap-1 px-2 py-0.5 bg-emerald-500/20 rounded-full">
//                   <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-blink" />
//                   <span className="text-[8px] text-emerald-300 font-medium">Live</span>
//                 </div>
//               </div>
//               <p className="text-[8px] text-blue-300/40">© 2026 Timely Health Care</p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   // Tooltip for collapsed sidebar
//   const Tooltip = () => {
//     if (!hoveredItem || isSidebarOpen) return null;
//     return (
//       <div
//         className="fixed z-[100] bg-gradient-to-r from-blue-600 to-blue-700 text-white text-xs px-3 py-1.5 rounded-lg shadow-xl pointer-events-none whitespace-nowrap border border-blue-400/30 animate-fade-in"
//         style={{
//           left: `${tooltipPosition.x}px`,
//           top: `${tooltipPosition.y}px`,
//         }}
//       >
//         {hoveredItem}
//       </div>
//     );
//   };

//   return (
//     <div className="flex h-screen bg-gray-50 overflow-hidden font-sans">
//       {/* Mobile Overlay */}
//       <AnimatePresence>
//         {isMobileSidebarOpen && (
//           <motion.div 
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"
//             onClick={toggleMobileSidebar}
//           />
//         )}
//       </AnimatePresence>

//       {/* Sidebar */}
//       <aside 
//         className={`fixed inset-y-0 left-0 z-50 transition-all duration-300 ease-in-out lg:relative lg:translate-x-0
//           ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
//           ${isSidebarOpen ? 'w-64' : 'lg:w-16 w-64'}
//         `}
//       >
//         <div className="h-full bg-[#1E40AF] shadow-2xl">
//           <SidebarContent />
//         </div>
//       </aside>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
//         {/* Header - Blue Navbar */}
//         <header className="sticky top-0 z-30 bg-[#1E40AF] shadow-lg flex items-center justify-between px-4 lg:px-6 h-14 flex-shrink-0">
//           <div className="flex items-center gap-4">
//             <button 
//               onClick={toggleMobileSidebar} 
//               className="lg:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-colors focus:outline-none"
//             >
//               <FiMenu size={20} strokeWidth={2.5} />
//             </button>
            
//             {/* Breadcrumb */}
//             <div className="hidden sm:flex items-center gap-2">
//               <span className="text-xs text-white">Recruitment</span>
//               <span className="text-blue-300 text-xs">/</span>
//               <span className="text-xs font-medium text-white">
//                 {allNavItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
//               </span>
//             </div>
//           </div>

//           <div className="flex items-center gap-4">
//             {/* Wallet Display in Navbar */}
//             <div className="relative">
//               <motion.div 
//                 whileHover={{ scale: 1.05 }}
//                 className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-gradient-to-r from-emerald-500/20 to-teal-500/20 border border-emerald-400/30 backdrop-blur-sm"
//               >
//                 <div className="relative">
//                   {!walletLoading && walletCoins !== null && (
//                     <span className="absolute -top-1 -right-2 w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
//                   )}
//                 </div>
//                 {walletLoading ? (
//                   <div className="w-12 h-4 bg-white/10 rounded animate-pulse" />
//                 ) : (
//                   <div>
//                     <span className="text-xs font-bold text-white">
//                       {walletCoins !== null ? walletCoins : '---'}
//                     </span>
//                     <span className="text-[9px] text-emerald-300 ml-1">coins</span>
//                   </div>
//                 )}
//               </motion.div>
//             </div>

//             {/* User Profile */}
//             <div className="flex items-center gap-3">
//               <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-400 to-indigo-500 text-white flex items-center justify-center font-bold shadow-md">
//                 <span className="text-sm">HR</span>
//               </div>
//               <div className="hidden md:block">
//                 <p className="text-xs font-semibold text-white">HR Manager</p>
//                 <p className="text-[10px] text-blue-200">admin@timelyhealth.com</p>
//               </div>
//             </div>
//           </div>
//         </header>

//         {/* Main Content Area */}
//         <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 p-4 lg:p-6">
//           <div className="max-w-[1600px] mx-auto">
//             <Outlet />
//           </div>
//         </main>
//       </div>

//       {/* Tooltips */}
//       <Tooltip />
//     </div>
//   );
// };

// // Add this style to your global CSS or component
// const styles = `
//   .custom-scrollbar::-webkit-scrollbar {
//     width: 4px;
//   }
  
//   .custom-scrollbar::-webkit-scrollbar-track {
//     background: rgba(255, 255, 255, 0.1);
//     border-radius: 10px;
//   }
  
//   .custom-scrollbar::-webkit-scrollbar-thumb {
//     background: rgba(59, 130, 246, 0.5);
//     border-radius: 10px;
//   }
  
//   .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//     background: rgba(59, 130, 246, 0.8);
//   }

//   /* Blinking Animations */
//   @keyframes blink {
//     0%, 100% {
//       opacity: 1;
//       transform: scale(1);
//     }
//     50% {
//       opacity: 0.4;
//       transform: scale(0.8);
//     }
//   }

//   @keyframes blink-fast {
//     0%, 100% {
//       opacity: 1;
//     }
//     25% {
//       opacity: 0.5;
//     }
//     50% {
//       opacity: 1;
//     }
//     75% {
//       opacity: 0.5;
//     }
//   }

//   @keyframes soft-blink {
//     0%, 100% {
//       opacity: 1;
//       box-shadow: 0 0 0px rgba(255, 255, 255, 0);
//     }
//     50% {
//       opacity: 0.7;
//       box-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
//     }
//   }

//   @keyframes border-pulse {
//     0%, 100% {
//       opacity: 0.3;
//     }
//     50% {
//       opacity: 1;
//     }
//   }

//   @keyframes fade-in {
//     from {
//       opacity: 0;
//       transform: translateX(-10px);
//     }
//     to {
//       opacity: 1;
//       transform: translateX(0);
//     }
//   }

//   .animate-blink {
//     animation: blink 1.5s ease-in-out infinite;
//   }

//   .animate-blink-fast {
//     animation: blink-fast 0.8s ease-in-out infinite;
//   }

//   .animate-soft-blink {
//     animation: soft-blink 2s ease-in-out infinite;
//   }

//   .animate-border-pulse {
//     animation: border-pulse 2s ease-in-out infinite;
//   }

//   .animate-fade-in {
//     animation: fade-in 0.2s ease-out;
//   }

//   .animate-pulse-fast {
//     animation: blink-fast 0.6s ease-in-out infinite;
//   }
// `;

// // Inject styles
// if (typeof document !== 'undefined') {
//   const styleSheet = document.createElement("style");
//   styleSheet.textContent = styles;
//   document.head.appendChild(styleSheet);
// }

// export default AdminLayout;



import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { 
  FiHome, FiBriefcase, FiUsers, FiBarChart2, FiMail, FiClipboard, FiFileText,
  FiMap, FiLogOut, FiMenu, FiX, FiFilePlus, FiPlusCircle, FiList, FiChevronDown,
  FiCreditCard, FiGift, FiTag, FiUserCheck, FiStar, FiTrendingUp, FiZap,
  FiGrid, FiActivity, FiAward, FiHeart, FiCompass, FiShare2, FiCheckSquare, FiPlus, FiFolder
} from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [walletCoins, setWalletCoins] = useState(null);
  const [walletLoading, setWalletLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const fetchWalletData = async () => {
    const clientId = localStorage.getItem('clientId');
    if (!clientId) return;
    setWalletLoading(true);
    try {
      const response = await axios.get(`https://api.ingrainsystems.com/api/clients/my-wallet/${clientId}`);
      if (response.data.success) {
        setWalletCoins(response.data.data.totalCoins);
      }
    } catch (error) {
      console.error('Error fetching wallet data:', error);
    } finally {
      setWalletLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    fetchWalletData();
    const interval = setInterval(fetchWalletData, 30000);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(interval);
    };
  }, []);

  const toggleSidebar = () => {
    if (!isMobile) {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };
  const toggleMobileSidebar = () => setIsMobileSidebarOpen(!isMobileSidebarOpen);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/client-login');
  };

  const handleMouseMove = (e, itemName) => {
    setTooltipPosition({ x: e.clientX + 15, y: e.clientY - 10 });
    setHoveredItem(itemName);
  };

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const menuSections = [
    {
      title: "Core",
      items: [
        { path: '/recruitment-dashboard', label: 'Dashboard', icon: FiGrid }
      ]
    },
    {
      title: "Job Management",
      icon: FiBriefcase,
      type: "dropdown",
      items: [
        { path: '/job-post', label: 'All Jobs', icon: FiFolder },
        { path: '/post-new-job', label: 'Post New Job', icon: FiPlus, tag: { text: 'NEW', color: 'emerald' } },
        { path: '/job-positions-status', label: 'Job Status', icon: FiActivity },
        { path: '/job-applicants', label: 'Job Applicants', icon: FiUsers },
        { path: '/score', label: 'Scores', icon: FiAward }
      ]
    },
    {
      title: "Short Jobs",
      icon: FiZap,
      type: "dropdown",
      items: [
        { path: '/short-jobs', label: 'Post Short Job', icon: FiStar },
        { path: '/posted-short-jobs', label: 'Posted Short Jobs', icon: FiList },
        { path: '/short-job-applicants', label: 'Short Job Applicants', icon: FiUserCheck }
      ]
    },
    {
      title: "Assessments & Docs",
      items: [
        { path: '/assessment-manager', label: 'Assessments', icon: FiCheckSquare },
        { path: '/new-assessment', label: 'New Assessment', icon: FiFilePlus, tag: { text: 'NEW', color: 'emerald' } },
        { path: '/personal-documents', label: 'Personal Docs', icon: FiFileText },
        { path: '/all-medical-certificates', label: 'Medical Certificates', icon: FiHeart }
      ]
    },
    {
      title: "Communications",
      items: [
        { path: '/acceptance-letter', label: 'Acceptance Letters', icon: FiMail },
        { path: '/employee-journey', label: 'Employee Journey', icon: FiCompass }
      ]
    },
    {
      title: "Wallet & Rewards",
      items: [
        { path: '/mywallet', label: 'My Wallet', icon: FiCreditCard },
        { path: '/myreffral', label: 'Refer & Earn', icon: FiShare2 },
        { path: '/specialoffers', label: 'Special Offers', icon: FiTag, tag: { text: 'HOT', color: 'orange', icon: FiZap } }
      ]
    }
  ];

  const allNavItems = menuSections.flatMap(section => section.items);

  // Sidebar content for DESKTOP (can collapse/expand)
  const DesktopSidebarContent = () => (
    <div className="flex flex-col h-full relative bg-white border-r border-slate-200/80">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent" />
      
      {/* Header */}
      <div className="relative flex items-center justify-between h-14 px-4 bg-slate-50/50 border-b border-slate-200/60 backdrop-blur-sm">
        <div className={`flex items-center gap-2 transition-all duration-300 ${!isSidebarOpen && 'lg:hidden'}`}>
          <motion.div whileHover={{ scale: 1.05 }} className="w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white shadow-md">
            <span className="text-xs font-bold">IG</span>
          </motion.div>
          <div>
            <span className="font-bold text-slate-800 text-sm tracking-wide">INGRAIN-HIRE</span>
            <p className="text-[9px] text-slate-500 font-semibold uppercase tracking-wider">Management</p>
          </div>
        </div>
        
        {!isSidebarOpen && (
          <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="hidden lg:block w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center shadow-md">
            <span className="text-white font-bold text-xs">HR</span>
          </motion.div>
        )}
        
        <button onClick={toggleSidebar} className="hidden lg:flex p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
          <FiMenu size={18} />
        </button>
      </div>

      <nav className="flex-1 px-3 py-3 overflow-y-auto custom-scrollbar space-y-1">
        {menuSections.map((section, sectionIdx) => (
          <div key={sectionIdx} className="mb-2">
            {!isSidebarOpen ? (
              <div className="space-y-1.5">
                {section.items.map((item, idx) => (
                  <div key={idx} className="relative">
                    <NavLink
                      to={item.path}
                      onMouseEnter={(e) => handleMouseMove(e, item.label)}
                      onMouseMove={(e) => handleMouseMove(e, item.label)}
                      onMouseLeave={() => setHoveredItem(null)}
                      className={({ isActive }) => `group relative flex items-center justify-center p-2.5 rounded-xl transition-all duration-200 ${
                        isActive 
                          ? 'bg-indigo-50 text-indigo-600 shadow-sm border border-indigo-100/50' 
                          : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                      }`}
                    >
                      <item.icon size={18} className="transition-transform duration-200 group-hover:scale-110" />
                    </NavLink>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {section.title && (
                  <div className="px-3 mb-1.5 mt-3">
                    <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
                  </div>
                )}
                <div className="space-y-0.5">
                  {section.type === "dropdown" ? (
                    <>
                      <div 
                        onClick={() => toggleDropdown(section.title)} 
                        className={`flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 ${
                          openDropdown === section.title 
                            ? 'text-indigo-600 bg-indigo-50/40 font-medium' 
                            : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                        }`}
                      >
                        <div className="flex items-center gap-3">
                          {section.icon && <section.icon size={18} className={openDropdown === section.title ? 'text-indigo-500' : 'text-slate-400 group-hover:text-slate-600'} />}
                          <span className="text-[13px] font-medium">{section.title}</span>
                        </div>
                        <FiChevronDown className={`transition-transform duration-300 text-slate-400 ${openDropdown === section.title ? 'rotate-180 text-indigo-500' : ''}`} size={14} />
                      </div>
                      <AnimatePresence>
                        {openDropdown === section.title && (
                          <motion.div 
                            initial={{ opacity: 0, height: 0 }} 
                            animate={{ opacity: 1, height: 'auto' }} 
                            exit={{ opacity: 0, height: 0 }} 
                            className="pl-3 mt-0.5 space-y-0.5 overflow-hidden border-l border-slate-100 ml-5"
                          >
                            {section.items.map((item, idx) => (
                              <NavLink 
                                key={idx} 
                                to={item.path} 
                                className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
                                  isActive 
                                    ? 'bg-indigo-50/70 text-indigo-600 font-semibold' 
                                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50/50'
                                }`}
                              >
                                {({ isActive }) => (
                                  <>
                                    <item.icon size={15} className={isActive ? 'text-indigo-500' : 'text-slate-400'} />
                                    <span className="text-[12px]">{item.label}</span>
                                    {item.tag && (
                                      <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                                        item.tag.color === 'orange' 
                                          ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                                          : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                      }`}>
                                        {item.tag.text}
                                      </span>
                                    )}
                                  </>
                                )}
                              </NavLink>
                            ))}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </>
                  ) : (
                    section.items.map((item, idx) => (
                      <NavLink 
                        key={idx} 
                        to={item.path} 
                        className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
                          isActive 
                            ? 'bg-gradient-to-r from-indigo-50 to-blue-50/30 text-indigo-600 font-semibold shadow-sm border border-indigo-100/50' 
                            : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                        }`}
                      >
                        {({ isActive }) => (
                          <>
                            <item.icon size={18} className={`transition-colors ${isActive ? 'text-indigo-600' : 'text-slate-400 group-hover:text-slate-600'}`} />
                            <div className="flex-1">
                              <div className="flex items-center gap-2">
                                <span className="text-[13px] font-medium">{item.label}</span>
                                {item.tag && (
                                  <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                                    item.tag.color === 'orange' 
                                      ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                                      : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                  }`}>
                                    {item.tag.text}
                                  </span>
                                )}
                              </div>
                            </div>
                            {isActive && (
                              <motion.div 
                                layoutId="activeIndicator"
                                className="w-1.5 h-1.5 rounded-full bg-indigo-500"
                              />
                            )}
                          </>
                        )}
                      </NavLink>
                    ))
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </nav>

      <div className="border-t border-slate-200/60 bg-slate-50/40 p-3">
        {!isSidebarOpen ? (
          <div className="flex flex-col items-center gap-2">
            <button 
              onClick={handleLogout} 
              onMouseEnter={(e) => handleMouseMove(e, 'Sign Out')}
              onMouseMove={(e) => handleMouseMove(e, 'Sign Out')}
              onMouseLeave={() => setHoveredItem(null)}
              className="p-2.5 rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
            >
              <FiLogOut size={18} />
            </button>
            <div className="mt-2 pt-2 border-t border-slate-200/60 w-full flex justify-center">
              <div className="w-6 h-6 rounded-lg bg-slate-100 flex items-center justify-center">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-2">
            <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200">
              <FiLogOut size={18} className="text-red-400 group-hover:text-red-600" />
              <div className="text-left">
                <span className="text-[13px] font-medium">Sign Out</span>
                <p className="text-[9px] text-slate-400">Exit application</p>
              </div>
            </button>
            <div className="pt-3 mt-2 border-t border-slate-200/60">
              <div className="flex items-center justify-between mb-1">
                <p className="text-slate-400 text-[8px] uppercase tracking-wider font-semibold">v2.0</p>
                <div className="flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-200 rounded-full">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
                  <span className="text-[8px] text-emerald-600 font-semibold uppercase tracking-wider">Live</span>
                </div>
              </div>
              <p className="text-[8px] text-slate-400">© 2026 Timely Health Care</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  // Sidebar content for MOBILE (ALWAYS shows text)
  const MobileSidebarContent = () => (
    <div className="flex flex-col h-full relative bg-white w-64 border-r border-slate-200/80">
      <div className="relative flex items-center justify-between h-14 px-4 bg-slate-50/50 border-b border-slate-200/60">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white shadow-md">
            <span className="text-xs font-bold">IG</span>
          </div>
          <div>
            <span className="font-bold text-slate-800 text-sm tracking-wide">INGRAIN-HIRE</span>
            <p className="text-[9px] text-slate-500 font-semibold uppercase tracking-wider">Management</p>
          </div>
        </div>
        <button onClick={toggleMobileSidebar} className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
          <FiX size={18} />
        </button>
      </div>

      <nav className="flex-1 px-3 py-3 overflow-y-auto space-y-1">
        {menuSections.map((section, sectionIdx) => (
          <div key={sectionIdx} className="mb-2">
            {section.title && (
              <div className="px-3 mb-1.5 mt-3">
                <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
              </div>
            )}
            <div className="space-y-0.5">
              {section.type === "dropdown" ? (
                <>
                  <div 
                    onClick={() => toggleDropdown(section.title)} 
                    className={`flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 ${
                      openDropdown === section.title 
                        ? 'text-indigo-600 bg-indigo-50/40 font-medium' 
                        : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {section.icon && <section.icon size={18} className={openDropdown === section.title ? 'text-indigo-500' : 'text-slate-400'} />}
                      <span className="text-[13px] font-medium">{section.title}</span>
                    </div>
                    <FiChevronDown className={`transition-transform duration-300 text-slate-400 ${openDropdown === section.title ? 'rotate-180 text-indigo-500' : ''}`} size={14} />
                  </div>
                  <AnimatePresence>
                    {openDropdown === section.title && (
                      <motion.div 
                        initial={{ opacity: 0, height: 0 }} 
                        animate={{ opacity: 1, height: 'auto' }} 
                        exit={{ opacity: 0, height: 0 }} 
                        className="pl-3 mt-0.5 space-y-0.5 overflow-hidden border-l border-slate-100 ml-5"
                      >
                        {section.items.map((item, idx) => (
                          <NavLink 
                            key={idx} 
                            to={item.path} 
                            onClick={() => setIsMobileSidebarOpen(false)} 
                            className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
                              isActive 
                                ? 'bg-indigo-50/70 text-indigo-600 font-semibold' 
                                : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50/50'
                            }`}
                          >
                            {({ isActive }) => (
                              <>
                                <item.icon size={15} className={isActive ? 'text-indigo-500' : 'text-slate-400'} />
                                <span className="text-[12px]">{item.label}</span>
                                {item.tag && (
                                  <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                                    item.tag.color === 'orange' 
                                      ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                                      : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                  }`}>
                                    {item.tag.text}
                                  </span>
                                )}
                              </>
                            )}
                          </NavLink>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </>
              ) : (
                section.items.map((item, idx) => (
                  <NavLink 
                    key={idx} 
                    to={item.path} 
                    onClick={() => setIsMobileSidebarOpen(false)} 
                    className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
                      isActive 
                        ? 'bg-gradient-to-r from-indigo-50 to-blue-50/30 text-indigo-600 font-semibold shadow-sm border border-indigo-100/50' 
                        : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                    }`}
                  >
                    {({ isActive }) => (
                      <>
                        <item.icon size={18} className={isActive ? 'text-indigo-600' : 'text-slate-400'} />
                        <span className="text-[13px] font-medium">{item.label}</span>
                        {item.tag && (
                          <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                            item.tag.color === 'orange' 
                              ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                              : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                          }`}>
                            {item.tag.text}
                          </span>
                        )}
                      </>
                    )}
                  </NavLink>
                ))
              )}
            </div>
          </div>
        ))}
      </nav>

      <div className="border-t border-slate-200/60 bg-slate-50/40 p-3">
        <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200">
          <FiLogOut size={18} className="text-red-400 group-hover:text-red-600" />
          <div className="text-left">
            <span className="text-[13px] font-medium">Sign Out</span>
            <p className="text-[9px] text-slate-400">Exit application</p>
          </div>
        </button>
        <div className="pt-3 mt-2 border-t border-slate-200/60">
          <div className="flex items-center justify-between mb-1">
            <p className="text-slate-400 text-[8px] uppercase tracking-wider font-semibold">v2.0</p>
            <div className="flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-200 rounded-full">
              <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
              <span className="text-[8px] text-emerald-600 font-semibold uppercase tracking-wider">Live</span>
            </div>
          </div>
          <p className="text-[8px] text-slate-400">© 2026 Timely Health Care</p>
        </div>
      </div>
    </div>
  );

  const Tooltip = () => {
    if (!hoveredItem || isSidebarOpen || isMobile) return null;
    return (
      <div className="fixed z-[100] bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-xs px-3 py-1.5 rounded-lg shadow-xl pointer-events-none whitespace-nowrap border border-indigo-400/30 animate-fade-in"
        style={{ left: `${tooltipPosition.x}px`, top: `${tooltipPosition.y}px` }}
      >
        {hoveredItem}
      </div>
    );
  };

  return (
    <div className="flex h-screen bg-slate-50/60 overflow-hidden font-sans text-slate-800">
      <AnimatePresence>
        {isMobileSidebarOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 lg:hidden"
            onClick={toggleMobileSidebar}
          />
        )}
      </AnimatePresence>

      {/* Sidebar - Mobile and Desktop layouts */}
      {isMobile ? (
        <aside className={`fixed inset-y-0 left-0 z-50 transition-all duration-300 ease-in-out ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <MobileSidebarContent />
        </aside>
      ) : (
        <aside className={`hidden lg:block transition-all duration-300 ease-in-out relative ${isSidebarOpen ? 'w-64' : 'w-16'}`}>
          <DesktopSidebarContent />
        </aside>
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
        <header className="sticky top-0 z-30 bg-white/95 border-b border-slate-200/80 shadow-slate-100/50 shadow-sm flex items-center justify-between px-4 lg:px-6 h-14 backdrop-blur-md">
          <div className="flex items-center gap-4">
            <button onClick={toggleMobileSidebar} className="lg:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors">
              <FiMenu size={20} />
            </button>
            
            <div className="flex items-center gap-2">
              <span className="text-xs text-slate-500 font-medium hidden sm:inline">Recruitment</span>
              <span className="text-slate-300 text-xs hidden sm:inline">/</span>
              <span className="text-xs font-semibold text-slate-800 truncate max-w-[150px]">
                {allNavItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-3 sm:gap-4">
            <div className="relative">
              <motion.div whileHover={{ scale: 1.05 }} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 sm:py-1.5 rounded-xl bg-emerald-50 border border-emerald-200/80 shadow-sm">
                {walletLoading ? (
                  <div className="w-10 sm:w-12 h-3 sm:h-4 bg-slate-100 rounded animate-pulse" />
                ) : (
                  <div className="flex items-baseline gap-0.5 sm:gap-1">
                    <span className="text-xs sm:text-sm font-bold text-emerald-700">
                      {walletCoins !== null ? walletCoins : '---'}
                    </span>
                    <span className="text-[8px] sm:text-[9px] text-emerald-600 font-semibold uppercase tracking-wider">coins</span>
                  </div>
                )}
              </motion.div>
            </div>

            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 text-white flex items-center justify-center font-bold shadow-sm">
                <span className="text-xs sm:text-sm">HR</span>
              </div>
              <div className="hidden sm:block text-left">
                <p className="text-xs font-semibold text-slate-800">HR Manager</p>
                <p className="text-[10px] text-slate-500 font-medium font-sans">admin@timelyhealth.com</p>
              </div>
            </div>
          </div>
        </header>

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-slate-50/50 p-3 sm:p-4 lg:p-6">
          <div className="max-w-[1600px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      <Tooltip />
    </div>
  );
};

const styles = `
  .custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
  .custom-scrollbar::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.03); border-radius: 10px; }
  .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(99, 102, 241, 0.2); border-radius: 10px; }
  .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(99, 102, 241, 0.4); }
  @keyframes blink { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.4; transform:scale(0.8); } }
  @keyframes fade-in { from { opacity:0; transform:translateX(-10px); } to { opacity:1; transform:translateX(0); } }
  .animate-blink { animation: blink 1.5s ease-in-out infinite; }
  .animate-fade-in { animation: fade-in 0.2s ease-out; }
`;

if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

export default AdminLayout;